import React, { PureComponent } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Table,
} from 'reactstrap';
import { CLOUDINARY_THUMB } from '../../helpers/cloudinaryConstants';
import AddressInput from '../Components/AddressInput/AddressInput';

class LinkBusinessToOwner extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      businessName: '',
      businessCity: '',
      newBusinessName: '',
      newBusinessLocation: {},
      newBusinessContact: '',
      selectedBusinessID: '',
      confirmText: 'Search',
      cancelText: 'Cancel',
      cancelColor: 'secondary',
      header: 'Link Business',
      addBusinessClicked: false,
      errors: {
        name: false,
        location: false,
        contact: false,
      },
    };
    this.onQueryInputName = this.onQueryInputName.bind(this);
    this.onQueryInputCity = this.onQueryInputCity.bind(this);
    this.onQueryInputNewName = this.onQueryInputNewName.bind(this);
    this.onQueryInputNewCity = this.onQueryInputNewCity.bind(this);
    this.onQueryInputNewContact = this.onQueryInputNewContact.bind(this);
    this.onConfirmButtonClicked = this.onConfirmButtonClicked.bind(this);
    this.onClickBusiness = this.onClickBusiness.bind(this);
    this.onAddBusiness = this.onAddBusiness.bind(this);
    this.onLocationUpdate = this.onLocationUpdate.bind(this);
  }

  componentDidUpdate() {
    this.setState(
      {
        businessName: this.props.inputBusinessName,
        businessCity: this.props.inputBusinessCity,
        addBusinessClicked: this.props.addBusinessClicked,
      },
      () => {
        if (!this.state.addBusinessClicked)
          this.setState({
            header: 'Link Business',
            confirmText: 'Search Business',
          });
      }
    );
  }

  onQueryInputName(e) {
    this.setState({ businessName: e.target.value }, () => {
      this.props.onChange(this.state.businessName, this.state.businessCity);
    });
  }

  onQueryInputCity(e) {
    this.setState({ businessCity: e.target.value }, () => {
      this.props.onChange(this.state.businessName, this.state.businessCity);
    });
  }

  onQueryInputNewName(e) {
    this.setState({ newBusinessName: e.target.value }, () => {
      this.props.onChangeAddBusiness(
        this.state.newBusinessName,
        this.state.businessCity,
        this.state.newBusinessContact
      );
    });
  }

  onQueryInputNewCity(e) {
    this.setState({ newBusinessLocation: e.target.value }, () => {
      this.props.onChangeAddBusiness(
        this.state.newBusinessName,
        this.state.newBusinessLocation,
        this.state.newBusinessContact
      );
    });
  }

  onQueryInputNewContact(e) {
    this.setState({ newBusinessContact: e.target.value }, () => {
      this.props.onChangeAddBusiness(
        this.state.newBusinessName,
        this.state.newBusinessLocation,
        this.state.newBusinessContact
      );
    });
  }

  onConfirmButtonClicked() {
    if (!this.state.addBusinessClicked) {
      this.props.onSearchBusiness();
    } else {
      const hasNoName = !this.state.newBusinessName.length;
      const hasNoLocation = !this.state.newBusinessLocation.coordinates;
      const hasNoContact = !this.state.newBusinessContact;
      if (hasNoName || hasNoLocation || hasNoContact) {
        this.setState({
          errors: {
            name: hasNoName || false,
            location: hasNoLocation || false,
            contact: hasNoContact || false,
          },
        });
      }
      this.props.addBusiness();
    }
    this.setState({
      businessName: '',
      businessCity: '',
      newBusinessName: '',
      newBusinessLocation: {},
      newBusinessContact: '',
    });
  }

  onAddBusiness() {
    this.props.onModalButtonClicked();
    this.setState({
      header: 'Add & Link Business',
      confirmText: 'Create & Link Business',
      addBusinessClicked: true,
    });
  }

  onClickBusiness(businessID) {
    this.props.onSelectBusiness(businessID);
  }

  onLocationUpdate(newLocation) {
    this.setState({
      newBusinessLocation: newLocation,
    });
  }

  renderResults() {
    return this.props.searchResults.map(business => (
      <tr
        onClick={() => {
          this.onClickBusiness(business.id);
        }}
        key={business.id}
        className='user-table__item'>
        <td className='text-center'>
          <div className='avatar'>
            <img
              src={`${CLOUDINARY_THUMB}/${business.avatar.image.cloudinaryId}`}
              className='img-avatar'
              alt={business.name}
            />
          </div>
        </td>
        <td>
          <div>{business.name}</div>
        </td>
        <td className='text-center'>{business.id}</td>
      </tr>
    ));
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}>
        <ModalHeader toggle={this.props.close}>{this.state.header}</ModalHeader>
        {!this.state.addBusinessClicked ? (
          <ModalBody>
            <FormGroup>
              <Label htmlFor='business name'>Business Name</Label>
              <Input
                type='text'
                name='businessName'
                id='business-name-input'
                placeholder='Enter Business Name'
                value={this.state.businessName}
                onChange={this.onQueryInputName}
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor='business city'>Business City</Label>
              <Input
                type='text'
                name='businessCity'
                id='business-city-input'
                placeholder='Enter Business City'
                value={this.state.businessCity}
                onChange={this.onQueryInputCity}
              />
            </FormGroup>

            {this.props.searchResults.length ? (
              <Table
                hover
                responsive
                className='table-outline mb-0 d-none d-sm-table user-table'>
                <thead className='thead-light'>
                  <tr>
                    <th className='text-center'>
                      <i className='icon-people' />
                    </th>
                    <th>Name</th>
                    <th className='text-center'>ID</th>
                  </tr>
                  <tr
                    onClick={() => {
                      this.onAddBusiness();
                    }}
                    key={'add-business'}
                    className='user-table__item'>
                    <td className='text-center'>
                      <div className='avatar'>
                        <img
                          src={`${CLOUDINARY_THUMB}/gonation.data.dev/default/img-bzn-avatar-full.png`}
                          className='img-avatar'
                        />
                      </div>
                    </td>
                    <td>
                      <div style={{ color: '#20bed6' }}>Add Business</div>
                    </td>
                    <td className='text-center'></td>
                  </tr>

                  {this.renderResults()}
                </thead>
                <tbody />
              </Table>
            ) : null}
          </ModalBody>
        ) : (
          <ModalBody>
            <FormGroup>
              {this.state.errors.name && (
                <p style={{ color: 'red', marginBottom: 0 }}>
                  This field is required
                </p>
              )}
              <Label htmlFor='new-business-name'>
                Business Name (required)
              </Label>
              <Input
                type='text'
                name='newBusinessName'
                id='new-business-name-input'
                placeholder='Enter New Business Name'
                value={this.state.newBusinessName}
                onChange={this.onQueryInputNewName}
              />
            </FormGroup>

            <FormGroup>
              {this.state.errors.location && (
                <p style={{ color: 'red', marginBottom: 0 }}>
                  This field is required
                </p>
              )}
              <AddressInput
                onUpdateLocation={this.onLocationUpdate}
                selectedLocation={this.state.newBusinessLocation}
              />
            </FormGroup>

            <FormGroup>
              {this.state.errors.contact && (
                <p style={{ color: 'red', marginBottom: 0 }}>
                  This field is required
                </p>
              )}
              <Label htmlFor='new-business-contact'>
                Business Contact (required)
              </Label>
              <Input
                type='text'
                name='newBusinessContact'
                id='new-business-contact-input'
                placeholder='Enter New Business Contact'
                value={this.state.newBusinessContact}
                onChange={this.onQueryInputNewContact}
              />
            </FormGroup>
          </ModalBody>
        )}

        <ModalFooter>
          <Button
            color={this.state.cancelColor}
            onClick={this.props.onClose}
            disabled={this.props.buttonsDisabled}>
            {this.state.cancelText}
          </Button>
          <Button
            color='primary'
            onClick={this.onConfirmButtonClicked}
            disabled={this.props.buttonsDisabled}>
            {this.state.confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default LinkBusinessToOwner;



// WEBPACK FOOTER //
// ./src/views/Components/LinkBusinessToOwner.js